<template>
  <div v-if="tagList">
    <dara-header size="md">{{ $t('trending-tags') }}</dara-header>
    <dara-tag
      v-for="tag in tagList"
      :key="tag.id"
      :label="tag.name"
      :to="getTagLink(tag)"
      class="mr--md mb--md" />
    <hr class="text-muted">

    <dara-form :submit="searchTags">
      <dara-input
        v-model="tagInput"
        name="search input"
        type="text"
        rules="required|min:2"
        :placeholder="$t('search-tag-placeholder')" />
    </dara-form>

    <div v-if="tagResults">
      <dara-header
        class="mt-4"
        size="sm"
        margin="xl">
        {{ $t('results') }}
      </dara-header>
      <dara-tag
        v-for="tag in tagResults"
        :key="tag.id"
        :label="tag.name"
        :to="getTagLink(tag)"
        class="mr--md mb--md" />
    </div>
  </div>
</template>

<script>
import { fetchTags, searchTag, getTagLink } from '@/modules/tag/tag.service';

export default {
  name: 'DaraTagSidebar',
  data() {
    return {
      tagList: null,
      tagInput: null,
      tagResults: null,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTagLink,
    fetch() {
      fetchTags()
        .then(data => {
          this.tagList = data.data;
        })
        .catch();
    },
    searchTags() {
      searchTag(this.tagInput)
        .then(({ data }) => {
          this.tagResults = data;
        })
        .catch();
    },
  },
};
</script>
